import axios from "axios";

export const getUsersSettings = (word, role, organizationId) => {
  const fields = [
    "id",
    "firstName",
    "lastName",
    "avatar",
    "role",
    "dataAuthorization"
  ];

  let roleGroup = "1";
  if (role && role !== "ALL") {
    roleGroup = role.slice(0, 1);
    role = role.slice(1);
  }

  let requestUrl = `${
    roleGroup === "2"
      ? "/organization/user"
      : "/authorization/apps-authorization"
  }`;
  let filter = [];

  if (roleGroup === "2") {
    filter.push({
      property: "role.type",
      value: role,
      operator: "eq"
    });
    filter.push({
      property: "role.organization",
      value: organizationId,
      operator: "eq"
    });
  } else {
    if (role && role !== "ALL") {
      requestUrl += "?appRole=" + role;
    }
  }
  if (word !== "" && word.length >= 3) {
    filter.push({
      property: "name",
      value: escape(word.trim()),
      operator: "like"
    });
  }

  let params = {
    filter: JSON.stringify(filter),
    fields: fields.join(","),
    limit: 100,
    organization_id: organizationId,
    app: "DATA"
  };

  return axios.get(requestUrl, {
    params
  });
};

export const saveUsersSettings = (
  role,
  allowCreateDashboard,
  allowAccessToDashboardList,
  allowAssociateDashboards,
  allowAccessToCollaboratorList,
  allowUpdateSlide,
  allowCreateSlide,
  allowAccessToSlideList,
  allowAccessToSettings,
  allowUpdateDashboard,
  usersIds,
  clientId
) => {
  const requestUrl = `/authorization/multi-save`;
  var formData = new FormData();
  for (let userId of usersIds) {
    formData.append("users_id[]", userId);
  }
  formData.append("client_id", clientId);
  formData.append("role", role);
  formData.append(
    "preferences[allowCreateDashboard]",
    Number(allowCreateDashboard)
  );
  formData.append(
    "preferences[allowUpdateDashboard]",
    Number(allowUpdateDashboard)
  );
  formData.append(
    "preferences[allowAccessToDashboardList]",
    Number(allowAccessToDashboardList)
  );
  formData.append(
    "preferences[allowAssociateDashboards]",
    Number(allowAssociateDashboards)
  );
  formData.append(
    "preferences[allowAccessToCollaboratorList]",
    Number(allowAccessToCollaboratorList)
  );
  formData.append(
    "preferences[allowAccessToSlideList]",
    Number(allowAccessToSlideList)
  );
  formData.append("preferences[allowCreateSlide]", Number(allowCreateSlide));
  formData.append("preferences[allowUpdateSlide]", Number(allowUpdateSlide));
  formData.append(
    "preferences[allowAccessToSettings]",
    Number(allowAccessToSettings)
  );
  formData.append("application", "DATA");
  return axios.post(requestUrl, formData);
};

export const deleteUsersSettings = (usersIds, clientId) => {
  const requestUrl = `/authorization/multi-delete`;

  var formData = new FormData();
  for (let userId of usersIds) {
    formData.append("users_id[]", userId);
  }
  formData.append("client_id", clientId);
  formData.append("application", "DATA");

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/authorizations.js